import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

// 临时首页
const HomeIndex: AppRouteRecordRaw = {
  path: '/home',
  name: 'HomePage',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '首页',
    requiresAuth: false,
    order: 6,
  },
  children: [
    {
      path: 'index',
      name: 'HomeIndex',
      component: () => import('@/views/homePage/index.vue'),
      meta: {
        title: '首页',
        requiresAuth: false,
        hideInMenu: true,
        roles: ['*'],
        activeMenu: 'HomeIndex',
      },
    },
  ],
};

export default HomeIndex;
